import type { DemoKey } from './keys';

export const tr: Partial<Record<DemoKey, string>> = {
  'app.eyebrow': 'Geometri · 3D',
  'panel.figure': 'Şekil',
  'panel.dims': 'Boyutlar',
  'panel.style': 'Görünüm',
  'panel.lines': 'Özel çizgiler',
  'style.body': 'Gövde',
  'style.line': 'Çizgi',
  'style.cut': 'Kesit',
  'style.labels': 'Köşe etiketleri',
  'group.face': 'Yüzey köşegenleri / doğurucular',
  'group.space': 'Köşegenler / eksenler / ortancalar',
  'split.label': 'Kesit',
  'btn.animate': 'Canlandır',
  'btn.reset': 'Sıfırla',
  'hint.line1': 'Döndürmek için sürükleyin · Yakınlaştırmak için kaydırın',
  'hint.line2': 'Seçmek için bir çizgiye tıklayın',
  'fig.cuboid': 'Dikdörtgenler prizması',
  'fig.cube': 'Küp',
  'fig.triPrism': 'Üçgen prizma',
  'fig.hexPrism': 'Altıgen prizma',
  'fig.tetrahedron': 'Düzgün dörtyüzlü',
  'fig.squarePyramid': 'Kare piramit',
  'fig.cylinder': 'Silindir',
  'fig.cone': 'Koni',
  'fig.sphere': 'Küre',
  'fig.frustumPyramid': 'Kesik piramit',
  'fig.frustumCone': 'Kesik koni',
  'dim.length': 'uzunluk',
  'dim.width': 'genişlik',
  'dim.height': 'yükseklik',
  'dim.side': 'kenar',
  'dim.radius': 'yarıçap',
  'dim.r1': 'alt yarıçap',
  'dim.r2': 'üst yarıçap',
  'dim.sideBase': 'taban kenarı',
  'dim.sideTop': 'üst kenar',
  'info.face': 'yüz',
  'info.center': 'merkezden',
  'info.diagonal': 'köşegen',
  'info.axial': 'eksenel köşegen',
  'info.diameter': 'çap',
  'info.generator': 'doğurucu',
  'info.axis': 'eksen',
  'info.height': 'yükseklik',
  'info.median': 'ortanca',
  'info.apothem': 'apotem',
  'info.diameterBase': 'taban çapı',
  'info.diameterTop': 'üst çap',
};
